import React from 'react';
import {
  FiZap, FiSearch, FiPhone, FiFileText, FiTrendingUp, FiHash,
  FiRefreshCw, FiCopy, FiBarChart2, FiMic, FiGrid, FiMapPin,
  FiLock, FiEdit3, FiAlertTriangle, FiCheck, FiArrowRight,
  FiUser, FiBox,
} from 'react-icons/fi';
import COILogo from '../../assets/images/COI_TH.svg';
import CommissionLogo from '../../assets/images/GenerateCommission_TH.svg';
import PolicyComparisonLogo from '../../assets/images/PolicyCopmarison.svg';
import DLLogo from '../../assets/images/DLLogo.svg';
import NAICSLogo from '../../assets/images/NAICS_logo.png';
import InvoiceScanLogo from '../../assets/images/InvoiceScan.svg';
import LossRunScanLogo from '../../assets/images/LossRunScan.svg';
import UpsellIndicatorLogo from '../../assets/images/UpsellIndicator.svg';
import MVRScanLogo from '../../assets/images/MVRScan.svg';
import HomeOwnerLogo from '../../assets/images/HomeOwnerLogo_TH.svg';
import QuoteProposalLogo from '../../assets/images/Quoteproposal.svg';
import PolicySummaryLogo from '../../assets/images/Policy Summary.svg';
import FenrisLogo from '../../assets/images/fenris.svg';
import SonantLogo from '../../assets/images/sonant.png';
import RabbitSignMiniLogo from '../../assets/images/RabbitSignMiniLogo.png';
import DataQualityLogo from '../../assets/images/DataQuality.svg';
import RateMLogo from '../../assets/images/Rate_MLogo.svg';
import ValChoiceLogo from '../../assets/images/valchoice.webp';
import MTMLogo from '../../assets/images/MTMLogo.png';
import MyCarrirFinderLog from '../../assets/images/MyCarrirFinderLog.svg';
import DataEnrichmentCommercialLogo from '../../assets/images/DataEnrichmentcommercial.svg';
import VehiclePrefillLogo from '../../assets/images/vehicle2_TH.svg';
import AcordDecPagesScanLogo from '../../assets/images/AcordandDecpagesscan_new.svg';
import PremFiScanLogo from '../../assets/images/scanDocument.svg';
import type { MarketplaceModuleResponse } from '../../services/marketplaceService';

type IconComp = React.ComponentType<{ size?: number }>;

/* ── Custom SVG asset wrappers (rendered as <img>) ── */
const svgImgStyle = { objectFit: 'contain' as const, display: 'block' };

const COIIcon: IconComp = ({ size = 22 }: { size?: number }) =>
  React.createElement('img', {
    src: COILogo,
    alt: 'COI',
    width: size,
    height: size,
    className: 'tbx-svg-icon',
    style: svgImgStyle,
  });

const CommissionIcon: IconComp = ({ size = 22 }: { size?: number }) =>
  React.createElement('img', {
    src: CommissionLogo,
    alt: 'Commission Scan',
    width: size,
    height: size,
    className: 'tbx-svg-icon',
    style: svgImgStyle,
  });

const PolicyComparisonIcon: IconComp = ({ size = 22 }: { size?: number }) =>
  React.createElement('img', {
    src: PolicyComparisonLogo,
    alt: 'Policy Comparison',
    width: size,
    height: size,
    className: 'tbx-svg-icon',
    style: svgImgStyle,
  });

const DLIcon: IconComp = ({ size = 22 }: { size?: number }) =>
  React.createElement('img', {
    src: DLLogo,
    alt: 'Driver License Scan',
    width: size,
    height: size,
    className: 'tbx-svg-icon',
    style: svgImgStyle,
  });

const NAICSIcon: IconComp = ({ size = 22 }: { size?: number }) =>
  React.createElement('img', {
    src: NAICSLogo,
    alt: 'NAICS Classification',
    width: size,
    height: size,
    className: 'tbx-svg-icon',
    style: svgImgStyle,
  });

const InvoiceScanIcon: IconComp = ({ size = 22 }: { size?: number }) =>
  React.createElement('img', {
    src: InvoiceScanLogo,
    alt: 'Invoice Scan',
    width: size,
    height: size,
    className: 'tbx-svg-icon',
    style: svgImgStyle,
  });

const LossRunScanIcon: IconComp = ({ size = 22 }: { size?: number }) =>
  React.createElement('img', {
    src: LossRunScanLogo,
    alt: 'Loss Run Scan',
    width: size,
    height: size,
    className: 'tbx-svg-icon',
    style: svgImgStyle,
  });

const UpsellIndicatorIcon: IconComp = ({ size = 22 }: { size?: number }) =>
  React.createElement('img', {
    src: UpsellIndicatorLogo,
    alt: 'Upsell Indicator',
    width: size,
    height: size,
    className: 'tbx-svg-icon',
    style: svgImgStyle,
  });

const MVRScanIcon: IconComp = ({ size = 22 }: { size?: number }) =>
  React.createElement('img', {
    src: MVRScanLogo,
    alt: 'MVR Scan',
    width: size,
    height: size,
    className: 'tbx-svg-icon',
    style: svgImgStyle,
  });

const HomeOwnerIcon: IconComp = ({ size = 22 }: { size?: number }) =>
  React.createElement('img', {
    src: HomeOwnerLogo,
    alt: 'Home Owner',
    width: size,
    height: size,
    className: 'tbx-svg-icon',
    style: svgImgStyle,
  });

const QuoteProposalIcon: IconComp = ({ size = 22 }: { size?: number }) =>
  React.createElement('img', {
    src: QuoteProposalLogo,
    alt: 'Quote Proposal',
    width: size,
    height: size,
    className: 'tbx-svg-icon',
    style: svgImgStyle,
  });

const PolicySummaryIcon: IconComp = ({ size = 22 }: { size?: number }) =>
  React.createElement('img', {
    src: PolicySummaryLogo,
    alt: 'Policy/Quote Analyzer and Summary',
    width: size,
    height: size,
    className: 'tbx-svg-icon',
    style: svgImgStyle,
  });

const FenrisIcon: IconComp = ({ size = 22 }: { size?: number }) =>
  React.createElement('img', {
    src: FenrisLogo,
    alt: 'Fenris Personal Line',
    width: size,
    height: size,
    className: 'tbx-svg-icon',
    style: svgImgStyle,
  });

const SonantIcon: IconComp = ({ size = 22 }: { size?: number }) =>
  React.createElement('img', {
    src: SonantLogo,
    alt: 'Sonant',
    width: size,
    height: size,
    className: 'tbx-svg-icon',
    style: svgImgStyle,
  });

const LinqsESignatureIcon: IconComp = ({ size = 22 }: { size?: number }) =>
  React.createElement('img', {
    src: RabbitSignMiniLogo,
    alt: 'Linqs E-Signature',
    width: size,
    height: size,
    className: 'tbx-svg-icon',
    style: svgImgStyle,
  });

const DataQualityIcon: IconComp = ({ size = 22 }: { size?: number }) =>
  React.createElement('img', {
    src: DataQualityLogo,
    alt: 'Data Quality Scan',
    width: size,
    height: size,
    className: 'tbx-svg-icon',
    style: svgImgStyle,
  });

const RateMLogoIcon: IconComp = ({ size = 22 }: { size?: number }) =>
  React.createElement('img', {
    src: RateMLogo,
    alt: 'Rate Risk Appetite',
    width: size,
    height: size,
    className: 'tbx-svg-icon',
    style: svgImgStyle,
  });

const ValChoiceIcon: IconComp = ({ size = 22 }: { size?: number }) =>
  React.createElement('img', {
    src: ValChoiceLogo,
    alt: 'Carrier Rating Service',
    width: size,
    height: size,
    className: 'tbx-svg-icon',
    style: svgImgStyle,
  });

const MTMScanIcon: IconComp = ({ size = 22 }: { size?: number }) =>
  React.createElement('img', {
    src: MTMLogo,
    alt: 'MTM Scan',
    width: size,
    height: size,
    className: 'tbx-svg-icon',
    style: svgImgStyle,
  });

const MyCarrierFinderIcon: IconComp = ({ size = 22 }: { size?: number }) =>
  React.createElement('img', {
    src: MyCarrirFinderLog,
    alt: 'My Carrier Finder',
    width: size,
    height: size,
    className: 'tbx-svg-icon',
    style: svgImgStyle,
  });

const DataEnrichmentCommercialIcon: IconComp = ({ size = 22 }: { size?: number }) =>
  React.createElement('img', {
    src: DataEnrichmentCommercialLogo,
    alt: 'Data Enrichment Commercial',
    width: size,
    height: size,
    className: 'tbx-svg-icon',
    style: svgImgStyle,
  });

const VehiclePrefillIcon: IconComp = ({ size = 22 }: { size?: number }) =>
  React.createElement('img', {
    src: VehiclePrefillLogo,
    alt: 'Vehicle Prefill',
    width: size,
    height: size,
    className: 'tbx-svg-icon',
    style: svgImgStyle,
  });

const AcordDecPagesScanIcon: IconComp = ({ size = 22 }: { size?: number }) =>
  React.createElement('img', {
    src: AcordDecPagesScanLogo,
    alt: 'Acord and Dec Pages Scan',
    width: size,
    height: size,
    className: 'tbx-svg-icon',
    style: svgImgStyle,
  });

const PremFiScanIcon: IconComp = ({ size = 22 }: { size?: number }) =>
  React.createElement('img', {
    src: PremFiScanLogo,
    alt: 'PremFi (PFA) Scan',
    width: size,
    height: size,
    className: 'tbx-svg-icon',
    style: svgImgStyle,
  });

/* ── API icon name → react-icon ── */
export const ICON_MAP: Record<string, IconComp> = {
  Zap: FiZap,
  Search: FiSearch,
  ScanLine: FiSearch,
  ScanSearch: FiSearch,
  Phone: FiPhone,
  FileText: FiFileText,
  FileSearch: FiFileText,
  FileSearch2: FiFileText,
  FileOutput: FiFileText,
  FilePlus: FiFileText,
  FilePlus2: FiFileText,
  TrendingUp: FiTrendingUp,
  TrendingDown: FiTrendingUp,
  Database: FiHash,
  RefreshCw: FiRefreshCw,
  GitCompare: FiCopy,
  BarChart2: FiBarChart2,
  Mic: FiMic,
  Building2: FiGrid,
  Home: FiGrid,
  Tag: FiHash,
  Truck: FiMapPin,
  Car: FiMapPin,
  CheckSquare: FiCheck,
  CreditCard: FiLock,
  PenLine: FiEdit3,
  Link: FiArrowRight,
  ClipboardList: FiFileText,
  Gauge: FiBarChart2,
  Receipt: FiFileText,
  Lock: FiLock,
  AlertTriangle: FiAlertTriangle,
};

/* ── Name-substring → icon (first match wins) ── */
const MODULE_NAME_ICON_MAP: Array<[string, IconComp]> = [
  ['commission',                 CommissionIcon],
  ['acord and dec pages scan',   AcordDecPagesScanIcon],
  ['dec pages scan',             AcordDecPagesScanIcon],
  ['acord',                      AcordDecPagesScanIcon],
  ['certificate of insurance',   COIIcon],
  ['classification',             NAICSIcon],
  ['naics',                      NAICSIcon],
  ['create new coi',             FiCopy],
  ['data enrichment commercial', DataEnrichmentCommercialIcon],
  ['data enrichment driver',     FenrisIcon],
  ['data enrichment personal',   FenrisIcon],
  ['data enrichment',            FiGrid],
  ['data quality',               DataQualityIcon],
  ['driver license',             DLIcon],
  ['linqs e-signature',          LinqsESignatureIcon],
  ['linqs-e-signature',          LinqsESignatureIcon],
  ['e-signature',                FiEdit3],
  ['signature',                  FiEdit3],
  ['home owner',                 HomeOwnerIcon],
  ['invoice',                    InvoiceScanIcon],
  ['loss run',                   LossRunScanIcon],
  ['upsell',                     UpsellIndicatorIcon],
  ['voice',                      FiMic],
  ['mvr',                        MVRScanIcon],
  ['policy comparison',          PolicyComparisonIcon],
  ['quote analyzer',             PolicySummaryIcon],
  ['quote proposal',             QuoteProposalIcon],
  ['policy',                     FiFileText],
  ['premfi',                     PremFiScanIcon],
  ['pfa scan',                   PremFiScanIcon],
  ['smart form',                 FiEdit3],
  ['quote linq',                 FiArrowRight],
  ['quote',                      FiBox],
  ['mtm',                        MTMScanIcon],
  ['rate risk',                  RateMLogoIcon],
  ['vehicle prefill',            VehiclePrefillIcon],
  ['vehicle',                    FiMapPin],
  ['carrier rating',             ValChoiceIcon],
  ['sonant',                     SonantIcon],
  ['nurix',                      FiGrid],
  ['ascend',                     FiArrowRight],
  ['work comp',                  FiBarChart2],
  ['coi',                        FiFileText],
  ['jump suit',                  FiUser],
  ['my carrier',                 MyCarrierFinderIcon],
];

const SVG_ICON_SUBSTRINGS = [
  'commission', 'certificate of insurance', 'policy comparison',
  'driver license', 'naics', 'classification',
  'invoice', 'loss run', 'upsell',
  'mvr', 'home owner', 'data enrichment commercial', 'data enrichment personal', 'data enrichment driver', 'quote proposal', 'quote analyzer',
  'sonant', 'linqs e-signature', 'linqs-e-signature', 'data quality', 'rate risk', 'carrier rating',
  'mtm', 'motor truck mutual', 'my carrier', 'vehicle prefill',
  'acord', 'dec pages scan', 'premfi', 'pfa scan',
];

export function isCustomSvgIcon(module: MarketplaceModuleResponse): boolean {
  if (module.moduleId === 'linqs-e-signature') return true;
  const lower = module.name.toLowerCase();
  return SVG_ICON_SUBSTRINGS.some((s) => lower.includes(s));
}


export function getModuleIcon(module: MarketplaceModuleResponse): IconComp {
  if (module.moduleId === 'linqs-e-signature') return LinqsESignatureIcon;
  if (module.moduleId === 'mtm-scan') return MTMScanIcon;
  if (module.moduleId === 'vehicle-prefill') return VehiclePrefillIcon;
  if (module.moduleId === 'acord-dec-pages-scan') return AcordDecPagesScanIcon;
  if (module.moduleId === 'premfi-pfa-scan') return PremFiScanIcon;
  const lower = module.name.toLowerCase();
  for (const [substr, Icon] of MODULE_NAME_ICON_MAP) {
    if (lower.includes(substr)) return Icon;
  }
  if (module.icon && ICON_MAP[module.icon]) return ICON_MAP[module.icon];
  return FiZap;
}

/* ── Category colours ── */
const CATEGORY_COLORS: Record<string, string> = {
  'AI Scan and Extract Data':                  '#7c3aed',
  'Third Party Data Enrichment Integrations':  '#3b82f6',
  'Other Features':                            '#f97316',
  'Linqs':                                     '#ec4899',
  Scanning: '#10b981',
  Support:  '#22d3ee',
  Policy:   '#f59e0b',
  Data:     '#8b5cf6',
  Tools:    '#ec4899',
};

export function getCatColor(category: string): string {
  return CATEGORY_COLORS[category] ?? '#8b5cf6';
}
